export interface AppFlow {
  name: string;
  start: string;
  orderDataRequired: boolean;
  sequence: Array<RouteSequence>;
  steps?: Array<string>;
}

export const StepNames = {
  SELECT_RETURN_ITEMS: "selectReturnItems",
  SELECT_RETURN_SHIPPING: "selectReturnShipping",
  CONFIRM_RETURN: "confirmReturn",
  COMPLETE_RETURN_AND_PRINT_LABELS: "completeReturnAndPrintLabels",
  CANCEL_ORDER: "cancelOrder",
  TECH_SUPPORT: "techSupport"
  // Add new steps here as needed
};

export interface RouteSequence {
  path: string;
  next?: string;
  back?: string;
}

export const defaultAppFlow: AppFlow = {
  name: "defaultFlow",
  start: "welcome",
  orderDataRequired: true,
  steps: [StepNames.SELECT_RETURN_ITEMS, StepNames.SELECT_RETURN_SHIPPING, StepNames.CONFIRM_RETURN, StepNames.COMPLETE_RETURN_AND_PRINT_LABELS],
  sequence: [
    {
      path: "welcome",
      next: "itemselection",
    },
    {
      path: "itemselection",
      next: "shippingoption",
      back: "welcome",
    },
    {
      path: "shippingoption",
      next: "returnconfirm",
      back: "itemselection",
    },
    {
      path: "returnconfirm",
      next: "labelprint",
      back: "shippingoption",
    },
    {
      path: "labelprint",
      back: "returnconfirm",
    },
  ],
};

export const loginAppFlow: AppFlow = {
  name: "loginFlow",
  start: "login",
  orderDataRequired: true,
  steps: [StepNames.SELECT_RETURN_ITEMS, StepNames.SELECT_RETURN_SHIPPING, StepNames.CONFIRM_RETURN, StepNames.COMPLETE_RETURN_AND_PRINT_LABELS],
  sequence: [
    {
      path: "login",
      next: "welcome",
    },
    {
      path: "welcome",
      next: "itemselection",
    },
    {
      path: "itemselection",
      next: "shippingoption",
      back: "welcome",
    },
    {
      path: "shippingoption",
      next: "returnconfirm",
      back: "itemselection",
    },
    {
      path: "returnconfirm",
      next: "labelprint",
      back: "shippingoption",
    },
    {
      path: "labelprint",
      back: "returnconfirm",
    },
  ],
};

export const formPostOrderB2C: AppFlow = {
  name: "formPostOrderB2C",
  start: "welcome",
  orderDataRequired: true,
  steps: [StepNames.SELECT_RETURN_ITEMS, StepNames.SELECT_RETURN_SHIPPING, StepNames.CONFIRM_RETURN, StepNames.COMPLETE_RETURN_AND_PRINT_LABELS],
  sequence: [
    {
      path: "welcome",
      next: "itemselection",
    },
    {
      path: "itemselection",
      next: "shippingoption",
      back: "welcome",
    },
    {
      path: "shippingoption",
      next: "returnconfirm",
      back: "itemselection",
    },
    {
      path: "returnconfirm",
      next: "labelprint",
      back: "shippingoption",
    },
    {
      path: "labelprint",
      back: "returnconfirm",
    },
  ],
};

export const formPostNoOrderB2C: AppFlow = {
  name: "formPostNoOrderB2C",
  start: "welcome",
  orderDataRequired: false,
  steps: [
    StepNames.SELECT_RETURN_ITEMS,
    StepNames.SELECT_RETURN_SHIPPING,
    StepNames.CONFIRM_RETURN,
    StepNames.COMPLETE_RETURN_AND_PRINT_LABELS,
  ],
  sequence: [
    {
      path: "welcome",
      next: "additems",
    },
    {
      path: "additems",
      next: "shippingoption",
      back: "welcome",
    },
    {
      path: "shippingoption",
      next: "returnconfirm",
      back: "additems",
    },
    {
      path: "returnconfirm",
      next: "labelprint",
      back: "shippingoption",
    },
    {
      path: "labelprint",
      back: "returnconfirm",
    },
  ],
};

export const formPostPrePopulatedOrder: AppFlow = {
  name: "formPostPrePopulatedOrder",
  start: "shippingoption",
  orderDataRequired: true,
  steps: [StepNames.CONFIRM_RETURN, StepNames.COMPLETE_RETURN_AND_PRINT_LABELS],

  sequence: [
    {
      path: "shippingoption",
      next: "returnconfirm",
    },
    {
      path: "returnconfirm",
      next: "labelprint",
      back: "shippingoption",
    },
    {
      path: "labelprint",
      back: "returnconfirm",
    },
  ],
};
export const loginAppFlowPrePopulated: AppFlow = {
  name: "loginAppFlowPrePopulated",
  start: "login",
  orderDataRequired: true,
  steps: [StepNames.SELECT_RETURN_SHIPPING, StepNames.COMPLETE_RETURN_AND_PRINT_LABELS],
  sequence: [
    {
      path: "login",
      next: "shippingoption",
    },
    {
      path: "shippingoption",
      next: "labelprint",
    },
    {
      path: "labelprint",
      back: "shippingoption",
    },
  ],
};

export const automaticLoginAppFlow: AppFlow = {
  name: "automaticLoginAppFlow",
  start: "cancelorder",
  orderDataRequired: true,
  steps: [StepNames.CANCEL_ORDER, StepNames.SELECT_RETURN_SHIPPING, StepNames.CONFIRM_RETURN, StepNames.COMPLETE_RETURN_AND_PRINT_LABELS],
  sequence: [
    {
      path: "cancelorder",
      next: "shippingoption",
    },
    {
      path: "shippingoption",
      next: "returnconfirm",
    },
    {
      path: "returnconfirm",
      next: "labelprint",
      back: "shippingoption",
    },
    {
      path: "labelprint",
      back: "returnconfirm",
    },
  ],
};

export const formPostPrePopulatedOrderTechSupportFlow: AppFlow = {
  name: "formPostPrePopulatedOrderTechSupportFlow",
  start: "techsupport",
  orderDataRequired: true,
  steps: [StepNames.TECH_SUPPORT, StepNames.SELECT_RETURN_SHIPPING, StepNames.CONFIRM_RETURN, StepNames.COMPLETE_RETURN_AND_PRINT_LABELS],

  sequence: [
    {
      path: "techsupport",
      next: "shippingoption",
    },
    {
      path: "shippingoption",
      next: "returnconfirm",
      back: "techsupport",
    },
    {
      path: "returnconfirm",
      next: "labelprint",
      back: "shippingoption",
    },
    {
      path: "labelprint",
      back: "returnconfirm",
    },
  ],
};

export const formPostOrderB2CTechSupportFlow: AppFlow = {
  name: "formPostOrderB2CTechSupportFlow",
  start: "welcome",
  orderDataRequired: true,
  steps: [
    StepNames.SELECT_RETURN_ITEMS,
    StepNames.TECH_SUPPORT,
    StepNames.SELECT_RETURN_SHIPPING,
    StepNames.CONFIRM_RETURN,
    StepNames.COMPLETE_RETURN_AND_PRINT_LABELS,
  ],
  sequence: [
    {
      path: "welcome",
      next: "itemselection",
    },
    {
      path: "itemselection",
      next: "techsupport",
      back: "welcome",
    },
    {
      path: "techsupport",
      next: "shippingoption",
      back: "itemselection",
    },
    {
      path: "shippingoption",
      next: "returnconfirm",
      back: "techsupport",
    },
    {
      path: "returnconfirm",
      next: "labelprint",
      back: "shippingoption",
    },
    {
      path: "labelprint",
      back: "returnconfirm",
    },
  ],
};
